module.exports = __webpack_public_path__ + "img/borescope_protoype3.f1ff910b.jpg";